<template>
  <div>
    <!-- 背景图 -->
    <el-image class="background-image" :src="backgroundImage" fit="cover"></el-image>

    <div class="news-page">
      <!-- Tabs -->
      <el-radio-group
        v-model="activeTab"
        @change="changeTab"
        fill="#3059da"
        class="news-group"
        style="margin-bottom: 30px;"
      >
        <el-radio-button label="0">公司新闻</el-radio-button>
        <el-radio-button label="1">行业新闻</el-radio-button>
        <el-radio-button label="2">学习干货</el-radio-button>
      </el-radio-group>
      <div class="content">
        <div class="news-list">
          <div v-for="news in currNews" :key="news.id" class="news-item">
            <el-card shadow="hover">
              <div class="news-header">
                <el-image :src="news.image" fit="cover" class="news-image"></el-image>
                <div class="news-content">
                  <div class="news-date">
                    <span class="news-day">{{ news.date.day }}</span>
                    <span class="news-month">{{ news.date.month }}</span>
                  </div>
                  <div class="news-text">
                    <h3 class="news-title">{{ news.title }}</h3>
                    <p class="news-description">{{ news.description }}</p>
                  </div>
                  <div class="line"></div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
      <el-pagination
        class="page"
        small
        layout="prev, next"
        prev-text="上一页"
        next-text="下一页"
        :total="50"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currNews: [],
      activeTab: '0',
      backgroundImage: require('@/assets/images/news.jpg'),
      newsList: [
        [
          {
            id: 1,
            image: require('@/assets/images/news1.png'),
            date: { day: '06', month: '2024-03' },
            title: '小小会议室里那些看不见的管理「黑洞」',
            description: '如何在会议室管理上给职场人打好辅助，提升效率？',
            url: '/article',
          },
          {
            id: 2,
            image: require('@/assets/images/news1.png'),
            date: { day: '28', month: '2024-02' },
            title: '贾维思荣获2023物联之星“中国物联网企业投资价值50强”',
            description:
              '贾维思凭借在数字化空间运营赛道的高成长性，深厚的技术研发实力以及丰富的项目经验，荣获“2023物联之星——中国物联网企业投资价值50强”',
          },
          {
            id: 3,
            image: require('@/assets/images/news1.png'),
            date: { day: '23', month: '2024-02' },
            title: '喜讯！贾维思获评“2023年深圳市专精特新企业”',
            description:
              '贾维思凭借在技术研发、产品创新、市场拓展、生态建设、企业管理等方面取得的突出成绩，成功获评“2023年深圳市专精特新中小企业”。',
          },
          {
            id: 4,
            image: require('@/assets/images/news1.png'),
            date: { day: '28', month: '2024-02' },
            title: 'Sora火爆“出道”！多行业又迎AI颠覆，如何握紧缰绳？',
            description:
              '结合2022年底大语言模型ChatGPT发布及后续的迭代动作，我们可以窥见包括大语言模型、文生视频模型在内的大模型行业还处在发展早期，但发展速度却要比过去其他行业更快',
          },
          {
            id: 5,
            image: require('@/assets/images/news1.png'),
            date: { day: '23', month: '2024-02' },
            title: '超高效班车管理，福利到位还省成本！',
            description:
              '班车福利虽好，如果管理乱做一锅粥。  不仅成本高，费时费力，还没捞着好口碑。 怎么管？  上贾维思平台，给你绝对想象不到的超高效班车管理！',
          },
        ],
        [
          {
            id: 3,
            image: require('@/assets/images/news1.png'),
            date: { day: '23', month: '2024-02' },
            title: '喜讯！贾维思获评“2023年深圳市专精特新企业”',
            description:
              '贾维思凭借在技术研发、产品创新、市场拓展、生态建设、企业管理等方面取得的突出成绩，成功获评“2023年深圳市专精特新中小企业”。',
          },
          {
            id: 4,
            image: require('@/assets/images/news1.png'),
            date: { day: '28', month: '2024-02' },
            title: 'Sora火爆“出道”！多行业又迎AI颠覆，如何握紧缰绳？',
            description:
              '结合2022年底大语言模型ChatGPT发布及后续的迭代动作，我们可以窥见包括大语言模型、文生视频模型在内的大模型行业还处在发展早期，但发展速度却要比过去其他行业更快',
          },
        ],
        [
          {
            id: 5,
            image: require('@/assets/images/news1.png'),
            date: { day: '23', month: '2024-02' },
            title: '超高效班车管理，福利到位还省成本！',
            description:
              '班车福利虽好，如果管理乱做一锅粥。  不仅成本高，费时费力，还没捞着好口碑。 怎么管？  上贾维思平台，给你绝对想象不到的超高效班车管理！',
          },
        ],
      ],
    }
  },
  mounted() {
    let i = this.$route.params.id || 0
    this.activeTab = i
    this.changeTab(i)
  },
  methods: {
    changeTab(i) {
      // newList = [[{}],[],[]]
      console.log(this.newsList[i])
      this.currNews = this.newsList[i]
    },
    handleTabClick(tab) {
      console.log(tab.name)
      // 根据 tab.name 来切换不同的新闻列表数据
    },
  },
}
</script>

<style>
.page {
  text-align: center;
  margin: 30px 0 30px;
  .btn-prev,
  .btn-next {
    margin: 0 5px;
  }
}
.el-card__body {
  padding: 0 !important;
  position: relative;
}
.el-card__body:hover .line {
  height: 132px;
  z-index: 9;
  transform-origin: center center;
  transition: height 0.4s ease-in;
}
.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-page {
  width: 1000px;
  margin: 0 auto;
}

.news-group {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.el-radio-button {
  height: 70px;
  flex: 1;
  text-align: center;
  border: none; /* 去掉边框线 */
}
.line {
  position: absolute;
  height: 0;
  width: 1px;
  transition: height 0.4s ease-in;
  background: #0080ff;
  transform-origin: center center;
  left: 379px;
}
.el-radio-button__inner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-size: 20px;
  color: #000;
  border: none; /* 去掉边框线 */
}
/* 设置鼠标悬停时的背景色 */
.el-radio-button__inner:hover {
  background-color: rgba(71, 71, 71, 0.2); /* 灰色带有透明度 */
  color: black;
}

.news-tabs {
  /* width: calc(100% / 3); */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  position: relative;
  margin-bottom: 20px;
  background-color: #fff;
  padding: 10px 0;
}

.news-item {
  margin-bottom: 20px;
}

.news-header {
  display: flex;
  flex: 1;
  background: #fff;
}

.news-image {
  width: 225px;
  height: 148px;
  margin-right: 20px;
}

.news-content {
  display: flex;
  align-items: center;
}

.news-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 114px;
  height: 88px;
  background-color: #fff;
  margin-right: 20px;
}

.news-day {
  font-size: 28px;
  color: #000;
  font-weight: 700;
}

.news-month {
  font-size: 14px;
  color: #666;
  font-weight: 700;
  padding-top: 5px;
}

.news-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  padding: 0 40px;
  border-left: 1px solid #e2e2e2;
}

.news-title {
  width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  font-weight: normal;
  color: #000;
}

.news-description {
  width: 500px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 定义文本的行数 */
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #666;
}

.hot-rank {
  flex: 1;
  background-color: #fff;
  padding: 25px 40px 30px 40px;
  border-radius: 8px;
}

.hot-rank-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.hot-rank-list {
  list-style: none;
  padding: 0;
}

.hot-rank-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.rank-index {
  font-weight: bold;
  color: #0080ff;
}

.rank-title {
  flex: 1;
  margin-left: 10px;
  color: #333;
  text-decoration: none;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .news-page {
    width: 100vw;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .news-group {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    flex-wrap: nowrap;
  }

  .el-radio-button {
    height: 40px;
    font-size: 14px;
    flex: 1;
  }

  .el-radio-button__inner {
    font-size: 14px;
  }

  .news-header {
    flex-direction: column;
    align-items: center;
  }

  .news-image {
    width: 100%;
    height: auto;
  }

  .news-content {
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
  }

  .news-date {
    flex-direction: row;
    justify-content: center;
    width: auto;
    margin: 0;
  }

  .news-text {
    border: none;
  }

  .news-day {
    font-size: 20px;
  }

  .news-month {
    font-size: 12px;
    margin-left: 5px;
  }

  .news-title,
  .news-description {
    width: 270px;
    text-align: center;
  }

  .news-title {
    font-size: 16px;
  }

  .news-description {
    font-size: 12px;
  }

  .background-image {
    width: 100%;
    height: 100%;
  }
}
</style>
